<template>
  <svg :class="svgClass" aria-hidden="true" :style="{ fontSize: fontSize + 'px' }" v-on="$listeners">
    <use :xlink:href="iconName" :fill="color" />
  </svg>
</template>

<script>
import './SvgIcon.js'

export default {
  name: 'SvgIcon',
  props: {
    name: {
      type: String,
      required: true
    },
    prefix: {
      type: String,
      default: 'icon-'
    },
    color: {
      type: String,
      default: ''
    },
    fontSize: {
      type: [Number, String],
      default: 14
    },
    className: {
      type: String,
      default: ''
    }
  },
  computed: {
    iconName() {
      return `#${this.prefix}${this.name}`
    },
    svgClass() {
      if (this.className) {
        return 'svg-icon ' + this.className
      } else {
        return 'svg-icon'
      }
    }
  }
}
</script>

<style scoped lang="scss">
.svg-icon {
  width: 1em;
  height: 1em;
  vertical-align: -0.15em;
  fill: currentColor;
  overflow: hidden;
}
</style>
